
import React from 'react'
import styled from "styled-components"

const myEnv = process.env
const protocole = myEnv.REACT_APP_SERVERPROTOCOLE
const host = myEnv.REACT_APP_SERVERHOSTNAME
const port = myEnv.REACT_APP_SERVERPORT
const apiTheatra = `${protocole}${host}:${port}`

const Titre = styled.a`
color:orange;
font-size: larger;
margin:10 auto;
`
const ObjetTheatra = styled.div`
margin:0 auto;
padding:10px;
`
const Meta = styled.div`
margin: 5px 15px;
`
const MetaHierarchie = styled.div`
margin: 5px 15px;
border-top: 1px solid grey;
border-bottom: 1px solid grey;
`

const Note = styled.div`
padding: 10px;
border: 1px solid grey;
text-align: justify;
`

const Ref = styled.a`
color: orange;
`

const affiche = (type, elem) => {

    //initialisation des paragraphes
    let titre = null
    let metas = null
    let auteurs = null
    let collaborateur = null
    let motclefs = null
    let notices = null
    let references = null
    let theatres = null
    let theatre_refs = null
    let phototheatres = null
    //ajout du prefixe pour cle unique
    const unique = elem.id

    const afficheNotice = (notice) => {
        const lien = `/notice/${notice.id}`
        const key = `${unique}-${notice.id}`
        const keyLien = `Lien-${unique}-${notice.id}`
        return ( <Meta key={key}><a key ={keyLien} href={lien}>{notice.titre}</a> ({notice.identifiant_zotero})</Meta>)
    }

    const afficheReference = (notice) => {
        const lien = `/notice/${notice.id}`
        const key = `${unique}-${notice.id}`
        const keyLien = `Lien-${unique}-${notice.id}`
        return ( <Meta key={key}><Ref key ={keyLien} href={lien}>{notice.titre}</Ref> ({notice.identifiant_zotero})</Meta>)
    }

    const afficheAuteur = (auteur) => {
        const lien = `/auteur/${auteur.id}`
        const key = `${unique}-${auteur.id}`
        const keyLien = `Lien-${unique}-${auteur.id}`
        return ( <Meta key={key}><a key ={keyLien} href={lien}>{auteur.prenom} {auteur.nom}</a></Meta>)
    }

    const afficheCollaborateur = (collaborateur) => {
        if (! collaborateur) {
            return null
        }
        const lien = `/collaborateur/${collaborateur.id}`
        const key = `${unique}-${collaborateur.id}`
        const keyLien = `Lien-${unique}-${collaborateur.id}`
        return ( <Meta key={key}><a key={keyLien} href={lien}>{collaborateur.prenom} {collaborateur.nom}</a> ({collaborateur.initiales})</Meta>)
    }

    const afficheMotclef = (motclef) => {
        const lien = `/motclef/${motclef.id}`
        const key = `${unique}-${motclef.id}`
        const keyLien = `Lien-${unique}-${motclef.id}`
        return ( <Meta key={key}><a key={keyLien} href={lien}>{motclef.libelle}</a> ({motclef.categorie}) </Meta>)
    }

    const afficheHierarchieMotClef = (motclef) => {
        if ( (motclef.enfants && motclef.enfants.length) || motclef.parent){
            const parent = motclef.parent ? <Meta>Mot clé parent : {afficheMotclef(motclef.parent)}</Meta> : null
            const enfants = elem.enfants.length ? <Meta>Mots clés enfants : {motclef.enfants.map(enfant => afficheMotclef(enfant))}</Meta> : null
            return (<MetaHierarchie>{parent}{enfants}</MetaHierarchie>)
        }
        return
    }

    const afficheTheatre = (theatre) => {
        const lien = `/theatre/${theatre.id}`
        const lienModif = `/theatre/edit/${theatre.id}`
        const key = `${unique}-${theatre.id}`
        const keyLien = `Lien-${unique}-${theatre.id}`
        const keyModif = `Modif-${unique}-${theatre.id}`
        return (
        <>
            <Meta key={key}><a key={keyLien} href={lien}>{theatre.site} {theatre.site_antique}</a>
             ({theatre.type_ed}) (<a key={keyModif} href={lienModif}>Modification</a>)</Meta>
        </>)
    }

    const afficheTheatreRef = (theatre) => {
        const lien = `/theatre/${theatre.id}`
        const lienModif = `/theatre/edit/${theatre.id}`
        const key = `${unique}-${theatre.id}`
        const keyLien = `Lien-${unique}-${theatre.id}`
        const keyModif = `Modif-${unique}-${theatre.id}`
        return (
        <>
            <Meta key={key}><Ref key={keyLien} href={lien}>{theatre.site} {theatre.site_antique}</Ref>
             ({theatre.type_ed}) (<a key={keyModif} href={lienModif}>Modification</a>)</Meta>
        </>)
    }

    const affichePhototheatre = (photo) => {
        const lien = `/phototheatre/${photo.id}`
        const lienModif = `/phototheatre/edit/${photo.id}`
        const key = `${unique}-${photo.id}`
        const keyLien = `Lien-${unique}-${photo.id}`
        const keyModif = `Modif-${unique}-${photo.id}`
        return ( <Meta key={key}><a key={keyLien} href={lien}>{photo.nom_fichier}</a> &nbsp;(<a key={keyModif} href={lienModif}>Modifier</a>)</Meta>)
    }

    const cle = (refElem) => {
        return (`${refElem}_${unique}`)
    }

    const elemHtml = (html) => {
        return {__html: html}
    }

    const urlEdit = (typeElement, id) => {
        return (`/${typeElement}/${id}`)
    }

    const afficheMeta = (libelle, valeur) => {
       if (valeur){
            if (libelle === 'abreviation'){
                valeur += " (abreviation)"
            }
            return(<Meta key={cle(libelle)}>{valeur}</Meta>)
        }
    }

    switch (type){
        case 'auteur':
            titre = <Titre key={cle(type)} href={urlEdit(type, elem.id)}>{elem.nom} {elem.prenom} </Titre>
            notices = elem.notices ? elem.notices.map(notice => afficheNotice(notice)) : null
            break
        case 'collaborateur':
            titre = <Titre key={cle(type)} href={urlEdit(type, elem.id)}>{elem.nom} {elem.prenom} </Titre>
            metas = <>
                {/*<Meta key={cle("meta_initiales")}>Initiales {elem.initiales}</Meta>*/}
                <Note key={cle("note")} dangerouslySetInnerHTML={elemHtml(elem.note)} ></Note>
            </>
            notices = elem.notices.map(notice => afficheNotice(notice))
            break
        case 'motclef':
            console.log(elem)
            titre = <Titre key={cle(type)} href={urlEdit(type, elem.id)}>{elem.libelle} </Titre>
            const metaUtils = elem.code ? (elem.order ? `${elem.code} - ${elem.order}` : elem.code) : (elem.order ? elem.order : null)
            metas =<>
                <Meta key={cle("categorie")}> {elem.categorie}</Meta>
                {afficheMeta("utils", metaUtils)}
                {afficheHierarchieMotClef(elem)}
                </>
            notices = elem.notices ? elem.notices.map(notice => afficheNotice(notice)) : null
            break
        case 'theatre':
            titre = <Titre key={cle(type)} href={urlEdit(type, elem.id)}>{elem.nom_complet} </Titre>
            metas =
            <>
                {afficheMeta("meta_nom_complet", elem.nom_complet)}
                {afficheMeta("meta_type_edifice", elem.type_ed)}
                {afficheMeta("meta_type_autre", elem.type_autre)}
                {afficheMeta("meta_specifique", elem.specifique)}
                {afficheMeta("abreviation", elem.abreviation)}
                {afficheMeta("meta_localite", elem.localite)}
                {afficheMeta("meta_lieudit", elem.lieu_dit)}
            </>
            notices = elem.notices.map(notice => afficheNotice(notice))
            references = elem.references.map(notice => afficheReference(notice))
            phototheatres = elem.phototheatres.map(phototheatre => affichePhototheatre(phototheatre))
            break
        case 'notice':
            titre = <Titre key={cle(type)} href={urlEdit(type, elem.id)}>{elem.titre}</Titre>
            const note = elem.note ? <Note key={cle("note")} dangerouslySetInnerHTML={elemHtml(elem.note)} ></Note> : null
            metas =
            <>
                <Meta key={cle("meta_id_zotero")}>Clé zotero {elem.identifiant_zotero}</Meta>
                <Meta key={cle("meta_ref_biblio")} dangerouslySetInnerHTML={elemHtml(elem.reference_biblio)}/>
                {elem.date_notice ? <Meta key={cle("meta_date")}>Date {elem.date_notice}</Meta> : null}
                {note}
            </>
            auteurs = elem.auteurs.map(auteur => afficheAuteur(auteur))
            motclefs = elem.motclefs.map(motclef => afficheMotclef(motclef))
            collaborateur = elem.collaborateur ? afficheCollaborateur(elem.collaborateur) : null
            theatres = elem.theatres.map(theatre => afficheTheatre(theatre))
            theatre_refs = elem.theatre_refs.map(theatre => afficheTheatreRef(theatre))
            break
        case 'phototheatre':
            let image = null
            titre = <Titre key={cle(type)} href={urlEdit(type, elem.id)}>Photo {elem.nom_fichier} </Titre>
            if (elem.url_nakala) {
                image = <img key={cle("photo")} src={elem.url_nakala.replace("embed", "data")} alt="photo_theatre" width="300"/>
            } else if (elem.url_locale) {
                image = <img key={cle("photo")} src={apiTheatra+elem.url_locale} alt="photo_theatre" width="300"/>
            }
            metas =
            <>
                <Meta key={cle("meta_nom_fichier")}>Fichier {elem.nom_fichier}</Meta>
                <Meta key={cle("meta_pays")}>{elem.pays}</Meta>
                <Meta key={cle("meta_date_photo")}>Date {elem.date_photo}</Meta>
                <Meta key={cle("meta_legende")}>{elem.legende}</Meta>
                <Meta key={cle("meta_copyright")}>{elem.copyright}</Meta>
                {image}
            </>
            theatres = (elem.theatre) ? afficheTheatre(elem.theatre) : null
            break
            case 'user':
                titre = <Titre key={cle(type)} href={urlEdit(type, elem.id)}>Utilisateur {elem.nom_complet} </Titre>
                metas =
                <>
                    <Meta key={cle("email")}>{elem.email}</Meta>
                    <Meta key={cle("role")}>{elem.role}</Meta>
                </>
                break
        default:
            break
    }

    return (<ObjetTheatra key={cle(type)}>
        {titre}
        {metas}
        {auteurs}
        {motclefs}
        {collaborateur}
        {notices}
        {references}
        {theatres}
        {theatre_refs}
        {phototheatres}
    </ObjetTheatra>)

}
/*  Composant qui assure l'ffichage d'un objet de type notice */
const Element = (params) => {

    const {type, elem} = params
    return ( affiche(type, elem))
}
export default Element